import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getCounsellorProfile, isCounsellorIdentity } from "../store/actions/counsellorActions";

/**
 * Counsellor-only auth guard.
 *
 * BUG-004/005: Auth token is now in an httpOnly cookie only. Bootstrap the
 * profile from the cookie itself so a hard refresh does not depend on a
 * client-readable storage hint.
 */
const CounsellorProtectedRoute = ({ children }) => {
  const { t } = useTranslation('global');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const requestedProfileRef = useRef(false);
  const { counsellor, loading, error } = useSelector((state) => state.counsellor);
  const hasValidCounsellor = isCounsellorIdentity(counsellor);

  useEffect(() => {
    if (hasValidCounsellor || loading) {
      return;
    }

    if (!requestedProfileRef.current) {
      requestedProfileRef.current = true;
      dispatch(getCounsellorProfile());
      return;
    }

    // Redirect only after the cookie bootstrap has completed and failed.
    if (!loading && error && !hasValidCounsellor) {
      navigate("/counsellor-login", { replace: true });
    }
  }, [dispatch, error, hasValidCounsellor, loading, navigate]);

  if (!hasValidCounsellor) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#F8FAFC',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #E2E8F0',
          borderTop: '4px solid #113F67',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <p style={{
          marginTop: '16px',
          color: '#475569',
          fontSize: '16px',
          fontWeight: '500'
        }}>
          {t('protectedRoute.loading', 'Loading...')}
        </p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return hasValidCounsellor ? children : null;
};

export default CounsellorProtectedRoute;
